/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    var run = function () {
        dropdown();
    };
    if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(run, { timeout: 2000 });
    } else {
        window.setTimeout(run, 1);
    }
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
/* Share row: native share, copy link */
(function () {
    const shareRoot = document.querySelector('.rx-share');
    if (!shareRoot) return;

    const nativeBtn = shareRoot.querySelector('[data-rx-share-native]');
    if (nativeBtn && typeof navigator.share === 'function') {
        nativeBtn.hidden = false;
        nativeBtn.addEventListener('click', function () {
            const title = nativeBtn.getAttribute('data-share-title') || document.title;
            const url = nativeBtn.getAttribute('data-share-url') || window.location.href;
            navigator.share({ title: title, url: url }).catch(function () {});
        });
    }

    const copyBtn = shareRoot.querySelector('[data-rx-copy-link]');
    if (!copyBtn) return;

    const labelEl = copyBtn.querySelector('[data-rx-copy-label]');
    const statusEl = shareRoot.querySelector('[data-rx-copy-status]');
    const fallbackInput = shareRoot.querySelector('[data-rx-copy-fallback]');
    const defaultLabel = labelEl ? labelEl.textContent : 'COPY_LINK';

    const announceCopied = function () {
        if (labelEl) {
            labelEl.textContent = 'COPIED';
            window.setTimeout(function () {
                labelEl.textContent = defaultLabel;
            }, 2000);
        }
        if (statusEl) {
            statusEl.textContent = 'Link copied';
            window.setTimeout(function () {
                statusEl.textContent = '';
            }, 2000);
        }
    };

    const copyFallback = function (url) {
        if (!fallbackInput) return false;
        fallbackInput.value = url;
        fallbackInput.setAttribute('aria-hidden', 'false');
        fallbackInput.focus();
        fallbackInput.select();
        let ok = false;
        try {
            ok = document.execCommand('copy');
        } catch (e) {
            ok = false;
        }
        fallbackInput.setAttribute('aria-hidden', 'true');
        return ok;
    };

    copyBtn.addEventListener('click', function () {
        const url = copyBtn.getAttribute('data-share-url') || window.location.href;
        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            navigator.clipboard.writeText(url).then(announceCopied).catch(function () {
                if (copyFallback(url)) announceCopied();
            });
        } else if (copyFallback(url)) {
            announceCopied();
        }
    });
})();
